export default "__VITE_ASSET__BHzNLTl$__"